import { css } from "styled-components"

// ログイン・登録・再設定・メール確認の画面は、テーマに関係なく白地で組んである。
// 一方で antd の CSS は referrer で切り替わり（lib/theme.ts）、cms 以外から来ると
// antd.dark.css が当たる。そのままだと入力した文字とプレースホルダーが白地に白で
// 見えず、Alert も黒地になるので、白地の画面の中だけ antd の色をライトに戻す。
export const lightAntOverrides = css`
  .ant-input,
  .ant-input-affix-wrapper {
    background-color: #fff;
    border-color: #d0d5dd;
    color: #101828;
  }

  .ant-input-affix-wrapper > input.ant-input {
    background-color: transparent;
    color: #101828;
  }

  .ant-input::placeholder {
    color: #98a2b3;
  }

  .ant-input-password-icon.anticon {
    color: #667085;
  }

  .ant-btn:not(.ant-btn-primary):not(.ant-btn-link) {
    background-color: #fff;
    border-color: #d0d5dd;
    color: #344054;
  }

  .ant-alert {
    border: 1px solid transparent;
  }

  .ant-alert-message,
  .ant-alert-description {
    color: #101828;
  }

  .ant-alert-success {
    background-color: #ecfdf3;
    border-color: #abefc6;
  }

  .ant-alert-error {
    background-color: #fef3f2;
    border-color: #fecdca;
  }

  .ant-alert-info {
    background-color: #eff8ff;
    border-color: #b2ddff;
  }

  .ant-alert-warning {
    background-color: #fffaeb;
    border-color: #fedf89;
  }
`
